<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,5C13,5,11,5,11,5C11,5,11,7,11,7C11,7,13,7,13,7C13,7,13,5,13,5C13,5,13,5,13,5C13,5,13,5,13,5ZM13,11C13,11,11,11,11,11C11,11,11,13,11,13C11,13,13,13,13,13C13,13,13,11,13,11C13,11,13,11,13,11C13,11,13,11,13,11ZM13,8C13,8,11,8,11,8C11,8,11,10,11,10C11,10,13,10,13,10C13,10,13,8,13,8C13,8,13,8,13,8C13,8,13,8,13,8ZM15,0C15,0,1,0,1,0C0.4,0,0,0.4,0,1C0,1,0,15,0,15C0,15.6,0.4,16,1,16C1,16,15,16,15,16C15.6,16,16,15.6,16,15C16,15,16,1,16,1C16,0.4,15.6,0,15,0C15,0,15,0,15,0C15,0,15,0,15,0ZM14,14C14,14,2,14,2,14C2,14,2,2,2,2C2,2,14,2,14,2C14,2,14,14,14,14C14,14,14,14,14,14C14,14,14,14,14,14ZM7,11C7,11,5,11,5,11C5,11,5,13,5,13C5,13,7,13,7,13C7,13,7,11,7,11C7,11,7,11,7,11C7,11,7,11,7,11ZM10,11C10,11,8,11,8,11C8,11,8,13,8,13C8,13,10,13,10,13C10,13,10,11,10,11C10,11,10,11,10,11C10,11,10,11,10,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HelperManagement',
} as DefineComponent
</script>
